let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("64e3x")).then(() => parcelRequire('lsAsU'));